/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Submit_Review_Sponsor_DescInputs */

const en_directory_submit_review_sponsor_desc = /** @type {(inputs: Directory_Submit_Review_Sponsor_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unlimited submissions, dofollow, labeled sponsor placements on the board.`)
};

const zh_directory_submit_review_sponsor_desc = /** @type {(inputs: Directory_Submit_Review_Sponsor_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`无限提交、dofollow、看板上的赞助展示位。`)
};

/**
* | output |
* | --- |
* | "Unlimited submissions, dofollow, labeled sponsor placements on the board." |
*
* @param {Directory_Submit_Review_Sponsor_DescInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_review_sponsor_desc = /** @type {((inputs?: Directory_Submit_Review_Sponsor_DescInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_Review_Sponsor_DescInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_review_sponsor_desc(inputs)
	return zh_directory_submit_review_sponsor_desc(inputs)
});
export { directory_submit_review_sponsor_desc as "directory.submit.review.sponsor_desc" }